/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ChannelPageItemList from '../../pages/channel/ChannelPageItemList'
import {renderNewMoney} from '../../utils';

class Item extends Component {
    initMoney() {
        const {role, channel, granted, isRelay} = this.props;
        const lecture = this.props.content;
        let value = '';


        if (role.is_liveroom_vip && lecture.lecture_type !== 'pay_channel'  && lecture.lecture_type !== 'password_lecture' && lecture.lecture_type!=='open_lecture') {
            if (!isRelay) {
                // value = <p><span>VIP免费</span></p>;
            } else {
                if (channel.need_money && lecture.lecture_type === 'pay_lecture') {
                    value = granted ? '' : <p>￥{renderNewMoney(lecture.money)[0]}<span>.{renderNewMoney(lecture.money)[1]}</span></p>;
                }
            }
        } else if (channel.need_money) {
                if (role.is_manager && lecture.lecture_type === 'pay_lecture') {
                    value = lecture.limit_money ? <p>￥{renderNewMoney(lecture.limit_money.money)[0]}<span>.{renderNewMoney(lecture.limit_money.money)[1]}</span></p> : <p>￥{renderNewMoney(lecture.money)[0]}<span>.{renderNewMoney(lecture.money)[1]}</span></p>;
                } else if (!granted && lecture.lecture_type === 'pay_lecture') {
                    value = lecture.limit_money ? <p>￥{renderNewMoney(lecture.limit_money.money)[0]}<span>.{renderNewMoney(lecture.limit_money.money)[1]}</span></p> : <p>￥{renderNewMoney(lecture.money)[0]}<span>.{renderNewMoney(lecture.money)[1]}</span></p>;
                }
        } else if (lecture.lecture_type === 'pay_lecture') {
                value = lecture.limit_money ? <p>￥{renderNewMoney(lecture.limit_money.money)[0]}<span>.{renderNewMoney(lecture.limit_money.money)[1]}</span></p> : <p>￥{renderNewMoney(lecture.money)[0]}<span>.{renderNewMoney(lecture.money)[1]}</span></p>;
        }
        return value;
    }

    render() {
        const {content, granted, role, channel,course_access} = this.props
        let type = content.lecture_type === 'pay_channel'
        let access = role.is_liveroom_vip || granted
        if (!role.is_manager) {
            if(type && channel.is_relay && role.is_liveroom_vip &&  !granted){
                return <ChannelPageItemList  ownMethod={() => this.props.handleShowDialog()} content={content} course_access={course_access} role={role} type="lecture" channel={channel} channelGranted={granted} attr="channelIndex" channelIndexPrice={this.initMoney()}/>
            }

            if (!content.is_relay) {
                //如果不是管理员 且不是转播的
                if (type && !access) {
                    //如果是必须购买专栏 且不是vip或者购买过专栏
                    return <ChannelPageItemList  ownMethod={() => this.props.handleShowDialog()} content={content} course_access={course_access} role={role} type="lecture" channel={channel} channelGranted={granted} attr="channelIndex" channelIndexPrice={this.initMoney()}/>
                }
            } else {
                if (type && !granted) {
                    return <ChannelPageItemList ownMethod={() => this.props.handleShowDialog()} content={content} course_access={course_access} role={role} type="lecture" channel={channel} channelGranted={granted} attr="channelIndex" channelIndexPrice={this.initMoney()}/>
                }
            }
        }

        // 没有内容的录播课
        if (['audio', 'video'].indexOf(content.lecture_mode) > -1 && !content.has_uploaded_content) {
            return <ChannelPageItemList ownMethod={() => this.props.handleShowDialog('recordNone')} content={content} course_access={course_access} role={role} type="lecture" channel={channel} channelGranted={granted} attr="channelIndex" channelIndexPrice={this.initMoney()}/>
        }

        return <ChannelPageItemList content={content} role={role} type="lecture" channel={channel} course_access={course_access} channelGranted={granted} attr="channelIndex" channelIndexPrice={this.initMoney()}/>
    }
}

class ChannelLectureList extends Component{
    handleBuy() {
        let target = document.querySelector('.class_for_maincoupon')
        if (target) {
            target.click()
        }
    }

    handleShowDialog(type = 'channelPay') {
        if (type === 'channelPay') {
            this.props.dispatch({
                type: 'TOASTSHOW',
                payload: {
                    toastMain: '点击底部按钮',
                    toastSub: '购买专栏'
                }
            })
            this.toastTimer = setTimeout(() => {
                this.props.dispatch({
                    type: 'TOASTHIDE'
                })
            }, 2000)
        }

        if (type === 'recordNone') {
            let {role} = this.props
            this.props.dispatch({
                type: 'TOASTSHOW',
                payload: {
                    toastMain: (role.is_manager || role.is_lecturer) ? '课程暂无内容' : '课程近期更新',
                    toastSub: (role.is_manager || role.is_lecturer) ? '请前往微课后台上传' : '敬请期待'
                }
            })
            this.toastTimer = setTimeout(() => {
                this.props.dispatch({
                    type: 'TOASTHIDE'
                })
            }, 2000)
        }
    }

    componentWillUnmount() {
        this.toastTimer && clearTimeout(this.toastTimer)
        this.props.dispatch({type: 'TOASTHIDE'})
    }

    render() {
        const {lectures,course_access} = this.props;
        return(
            <div className="channel-lecture-list box" id="lecture-list">
                {lectures.map((lecture) => (
                    <Item
                        content={lecture}
                        key={lecture.id}
                        course_access={course_access}
                        role={this.props.role}
                        channel={this.props.channel}
                        granted={this.props.granted}
                        isRelay={this.props.isRelay}
                        handleShowDialog={this.handleShowDialog.bind(this)}
                    />
                ))}
            </div>
        )
    }
}

export default connect((state) => ({
    lectures: state.channel.lectures,
    course_access:state.channel.access_datas,
    //给专栏目录算价格用的
    role: state.channel.role,
    channel: state.channel.channel,
    granted: state.channel.channel_access.granted,
    isRelay: state.channel.channel.is_relay,
}))(ChannelLectureList)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelLectureList.js